<app-header></app-header>
<app-sidebar></app-sidebar>
<!-- <app-right-sidebar></app-right-sidebar> -->
<router-outlet></router-outlet>
<app-page-loader></app-page-loader>
